import React from 'react';
import { IProps as ISkipToContentProps } from './SkipToContent.interface';
import SkipToContentComponent from './SkipToContent.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface ISkipToContentInputProps extends Omit<ISkipToContentProps, 'className'> {
    links: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any; // Allow passthrough of other props, e.g. for BlockWrapper or other future enhancements
}

const mapInputToProps = (input: ISkipToContentInputProps): ISkipToContentProps => {
    const { links, ...rest } = input;
    return {
        links: links && links.length > 0 ? links.map(link => translation.mapAnchorProps(link)) : [],
        ...rest
    } as ISkipToContentProps; // Ensure the return type matches, casting if necessary for spread props
};

const SkipToContentTranslation: React.FC<ISkipToContentInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={SkipToContentComponent}
        mapProps={mapInputToProps}
    />
);

export default SkipToContentTranslation;
